export function createLangWrapper(t) {
  // Special property names that should not be treated as translation keys
  const specialProps = new Set(['toString', 'valueOf', 'toJSON', 'then', 'constructor']);

  // Helper to create a 3rd-level proxy for namespace access
  const createDeepProxy = (key, innerKey) => {
    return new Proxy({}, {
      get(deepTarget, deepKey) {
        // Handle Symbols (Symbol.toPrimitive, Symbol.toStringTag, etc.)
        if (typeof deepKey === 'symbol') {
          if (deepKey === Symbol.toPrimitive) {
            return () => '';
          }
          if (deepKey === Symbol.toStringTag) {
            return 'String';
          }
          return undefined;
        }
        if (typeof deepKey !== 'string') {
          return undefined;
        }
        // Handle special methods for Vue's toDisplayString
        if (specialProps.has(deepKey)) {
          return deepKey === 'then' ? undefined : () => '';
        }
        return t(`${key}.${innerKey}.${deepKey}`, deepKey);
      }
    });
  };

  return new Proxy({}, {
    get(target, key) {
      // Handle Symbols
      if (typeof key === 'symbol') {
        return undefined;
      }
      if (typeof key !== 'string') {
        return undefined;
      }
      // Handle nested properties like 'labels.hello' or 'flowEditor.sections.controlFlow'
      return new Proxy({}, {
        get(innerTarget, innerKey) {
          // Handle Symbols (Symbol.toPrimitive, Symbol.toStringTag, etc.)
          if (typeof innerKey === 'symbol') {
            if (innerKey === Symbol.toPrimitive) {
              return () => '';
            }
            if (innerKey === Symbol.toStringTag) {
              return 'String';
            }
            return undefined;
          }
          if (typeof innerKey !== 'string') {
            return undefined;
          }
          // Handle special methods for Vue's toDisplayString - return empty string
          // 'then' returns undefined to prevent Promise detection
          if (specialProps.has(innerKey)) {
            return innerKey === 'then' ? undefined : () => '';
          }
          // Check if this is a nested object (3rd level) by trying the translation
          const directValue = t(`${key}.${innerKey}`, '');
          // If direct translation exists and is not an object placeholder, return it
          // Note: directValue === innerKey is valid (e.g., UUID: 'UUID', JWT: 'JWT')
          if (directValue && !directValue.startsWith('{')) {
            return directValue;
          }
          // Return a proxy for potential 3rd level access
          // The proxy handles toString/valueOf to return empty string for falsy fallbacks
          return createDeepProxy(key, innerKey);
        }
      });
    }
  });
}
